<template>
  <ErrorPageTemplate
    :errorCode="errorCode"
    :errorDescription="errorDescription"
  />
</template>

<script lang="ts">
export default {
  name: "BadGateway",

  metaInfo() {
    return {
      titleTemplate: `%s - ${this.errorCode}`
    }
  },

  data() {
    return {
      errorCode: 502,
      errorDescription: this.$t("error_pages.bad_gateway")
    }
  },

  components: {
    ErrorPageTemplate: () => import("@/components/ErrorPages/_components/ErrorPageTemplate")
  }
}
</script>
